//import $ from 'jquery';
import $ from "jquery";

import { set_accordian } from "../../scripts/accordian.js";
import { createGallery } from "../../scripts/create_gallery.js";
import { setImages, setImageText, getImage, setResponsiveImages } from "../../scripts/images.js";
import { tableResponsive } from "../../scripts/table.js";
import show404 from "./status_404.js";
import setModules from "../../scripts/modules.js";
import getBarnehageFakta from "../../scripts/get_barnehagefakta.js";
import { getApiWarnings } from "../../scripts/warnings";
import { 
  getRelatedBlocks, checkNested, 
  getRelations, getConfig, 
  setVariable, setLists,
  createGuid, adjustVariables, 
  testDynData, getDynDataOne, 
  checkDocument, removeExtraSpace,
  articlesExtend, setCorrectTemplate, urlRest 
} from "../../scripts/general_functions.js";
import { compileResources, insertSegments, checkSingleLinks } from "../../scripts/compile";
import { getImageByContentId } from "../../scripts/images";
import { setContactInfo, ViewContactByAPI } from "../../scripts/contact_functions.js";
import checkSemantics from "../../scripts/check_semantics.js";
import { skjema_link, skjema_inline } from "../../scripts/skjema.js";
import dayjs from "dayjs";
import "dayjs/locale/nb"; // load on demand
import article_default from "../views/article_default";
import article_focusarticle from "../views/article_focusarticle.js";
import article_bti_frontpage from "../views/article_bti_frontpage.js";
import { btiStep } from "../../scripts/bti.js";

dayjs.locale("nb");

export default function () {
  const getArticle = () => {
    let article_id = getPageUrl().contentid || getPageUrl().template;
    let articleCall = {
      type: "get",
      url: `${window.apiUrl}/api/PublicContentApi/find/${article_id}/${client.clientId}`,
    };

    if (getUrlAttr("preview") == "true") {
      articleCall.url = `${window.apiUrl}/api/ContentApi/find/${article_id}/preview`;
      articleCall.headers = {
        Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
        subscriptionId: client.clientId,
      };
    }

    if (article_id.match(/^aim:[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i)) {
      articleCall.url = `${window.apiUrl}/api/PublicContentApi/find/${article_id.substr(4)}/${client.clientId}`;
    } else if (!article_id.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i)) {
      if (article_id.match("/")) {
        let splittedid = article_id.split("/");
        article_id = splittedid[splittedid.length - 1];
      }
      articleCall.url = `${window.apiUrl}/api/PublicContentApi/findbynameinurl/${article_id}/${client.clientId}`;
    }

    $.when(
      $.ajax(articleCall),
      $.getJSON(`https://config.aim.prokom.no/clients/configbackup/variables_${client.nameId}.json`)
    )
      .fail(function (e) {
        console.error("Error", e);
        $("#contentHtml").html(show404());
        return;
      })
      .done(function (article, variables) {
        // console.log("[gotten article]", article)
        variables = adjustVariables(variables[0]);
        let joined = variables;

        if (!article) {
          // console.log("not article");
          $("#contentHtml").html(show404());
          return;
        } else if (!variables) {
          console.log("Mangler Karivars og karilinks");
        }

        article = article[0] || false;
        if (article.metaObject) {
          if (article.metaObject != "undefined") {
            article = articlesExtend(article);
          }

          console.log(article);

          if (article.metaParsed && article.pageTypeId === "mal_dynamisk") {
            let metaArticleTypeId = setCorrectTemplate(article.metaParsed);
            if (metaArticleTypeId) {
              article.pageTypeId = metaArticleTypeId;
            }
          }
        }

        if (article.extension !== null) {
          window.location = article.path;

          article.title = article.filename;
          article.contentObject = encodeURIComponent(`<p>
                        Dokumentet lastes ned automatisk. Dersom ikke nedlastningen skulle fungere, kan du klikke her: <a href="${article.path}">${article.path}</a>
                    </p>`);
        }

        const meta = article.metaObject || false;

        window.contentID = article.contentId;
        window.contentSubscription = client.clientId;

        getApiWarnings();

        let config = getConfig();
        document.title = `${article.title} - ${config.name}`;

        let urlPath = "";
        urlPath =
          article.shortNameInUrl || article.nameInUrl || article.contentId;
        let urlrest = urlRest(window.location.href);

        console.log("urlrest", urlrest);

        if (getUrlAttr("preview") != "true") {
          console.log("correct 2");
          const newPath = urlPath + urlrest;
          if (article.pageTypeId != "mal_blokk") {
            // https://richard.rollag.aim.prokom.no/9c6783d0-90cc-4a57-84d8-a075858b3ec6#se:utvalg/utvalgid:2

            console.log("correct 3", newPath);
            window.history.pushState(
              { path: newPath, pageTitle: `${article.title} - ${config.name}` },
              "",
              newPath
            );
          } else {
            console.log("correct 4", urlPath);
            window.history.pushState(
              { path: newPath, pageTitle: `${article.title} - ${config.name}` },
              "",
              "/blokk/" + contentID
            );
          }
        }

        let content = decodeURIComponent(article.contentObject) || ``;
        let decodingFailed = false;
        // Check if content needs to be decoded more ( has <, > or [space] decoded)
        while (!decodingFailed && (content.includes('%3C') || content.includes('%3E') || content.includes('%20'))) {
          try {
            content = decodeURIComponent(content);
            
          } catch {
            console.log("Extra urldecode failed");
            decodingFailed = true;
          }
        }

        if (article.pageTypeId === "mal_visittkort") {
          content = `
                                <p>
                                    <span class="h-card">
                                        <span id="editorBlokk">
                                            <span id="${article.contentId}">
                                                <span style="margin-right: 5px; font-weight: 500;">Kontaktkort:</span>
                                            <span style="font-style: italic;margin-right: 5px;">
                                        </span>
                                    </span>
                                </p>`;

          if (article.relatedContentObjects.length < 1) {
            let newA = JSON.parse(JSON.stringify(article));
            article.relatedContentObjects = [newA];
          }
        }
        if (article.pageTypeId === "mal_dynamisk") {
          // console.log("[is dynamisk]")

          let metaData = $.parseJSON(decodeURIComponent(meta));
          if (metaData.id === "f63340c6-b3c3-49c0-b8c8-a661b55cd946") {
            let bti = btiStep([{ obj: article, meta: metaData }]);
            content = bti;
            setTimeout(function () {
              $(".bti__step").addClass("d-block");
            }, 200);
          }

          if (article.relatedContentObjects.length < 1) {
            let newA = JSON.parse(JSON.stringify(article));
            article.relatedContentObjects = [newA];
          }
        }

        // console.log("[conent]",content, article.relatedContentObjects);
        content = setModules(content);
        content = compileResources(content, article.relatedContentObjects);

        let me = $("<div>" + content + "</div>");

        me.find(".cke_reset").remove();
        me.find('[contenteditable="true"]').removeAttr("contenteditable");

        me.find(".var_text").contents().unwrap();

        let allRelateds = [];
        // console.log("3", article);

        const pushRelatedContentObjects = (obj) => {
          if (obj.relatedContentObjects) {
            obj.relatedContentObjects.forEach((relObj) => {
              allRelateds.push(relObj);
              if (relObj.relatedContentObjects) {
                pushRelatedContentObjects(relObj);
              }
            });
          }
        };

        pushRelatedContentObjects(article);

        content = me.html();
        content = checkSingleLinks(content);
        content = removeExtraSpace(content);
        content = tableResponsive(content).html();
        content = setImages(content);
        content = setVariable(content, joined);
        content = content.replace(/href\=\"aim:/gim, 'href="/artikkel/');
        content = skjema_link(content);
        content = setLists(client.clientid, content);
        content = set_accordian(content);
        content = checkSemantics(content);
        content = insertSegments(content);

        // console.log("content third", content)
        let metaData = {},
          hasMainImage = false,
          hasRightColumn = false,
          rightColumn = ``,
          mainImage = ``;

        if (meta !== "undefined" && meta !== "mermeta") {
          metaData = JSON.parse(decodeURIComponent(meta));

          ViewContactByAPI(metaData, article.title, content);

          if (
            checkNested(metaData, "kontaktkort", "0", "kontaktkort_personnavn") && !(article.pageTypeId === "mal_enhetsmal" && content.match("APIDATA:BARNEHAGEFAKTA"))) {
            let contentToRightColumn = setContactInfo(metaData.kontaktkort, true);
            if (contentToRightColumn !== false) {
              rightColumn = contentToRightColumn;
            }
            if (rightColumn) {
              hasRightColumn = true;
            }
          }

          if (checkNested(metaData, "relasjoner", "0", "id")) {
            rightColumn += getRelations(metaData.relasjoner);
            if (rightColumn) {
              hasRightColumn = true;
            }
          }

          if (article.pageTypeId === "mal_enhetsmal" && content.match("APIDATA:BARNEHAGEFAKTA")) {
            let overrideContact = false;
            if (checkNested(metaData, "kontaktkort", "0", "kontaktkort_personnavn")) {
              overrideContact = setContactInfo(metaData.kontaktkort, false);
            }

            content = content.replace("APIDATA:BARNEHAGEFAKTA", "<div id='barnehagefakta-opinion'></div>");
            if (metaData.enhetsId.length > 0) {
              rightColumn += getBarnehageFakta(metaData, overrideContact);
              hasRightColumn = true;
            }
          }

          if (metaData.imageContentId !== undefined && metaData.relatedContentObjects) {
            const url = getImage(metaData.imageContentId, article.relatedContentObjects, "https://aimblob.blob.core.windows.net/aimfiles/daf64fb1-dc1a-4795-b1da-d2f8958a9ecd.jpg");
            mainImage = `<div class="article__introimage__container">
                            <img src="${url}" style="width:100%" alt="" class="article__introimage" >
                            <figcaption>${metaData.imageContentId}</figcaption>
                        </div>`;
            hasMainImage = true;
          } else if (metaData.imageContentId !== undefined && metaData.imageContentId.length > 0) {
            let imgId = createGuid();
            mainImage = `<div class="article__introimage__container">
                              <img src="" style="width:100%;" alt="" class="article__introimage" id="${imgId}" >
                              <figcaption class="article__imgtxt__text">${
                                metaData.imageDescription != undefined
                                  ? metaData.imageDescription
                                  : ""
                              }</figcaption>
                          </div>`;

            getImageByContentId(metaData.imageContentId, (img) => {
              if (img.url !== undefined && img.url.length > 0) {
                hasMainImage = true;
                $(`#${imgId}`).attr({"data-src": img.url, src: "/dist/images/transparent.png"});
                setResponsiveImages();
              } else {
                $(".image__container").innerHTML = "";
              }
            });
          }
        }

        if (article.relatedContentObjects) {
          let relatedContacts = getRelatedBlocks(article, "contact");

          if (relatedContacts.length > 0) {
            rightColumn += getRelations(relatedContacts);
            if (rightColumn) {
              hasRightColumn = true;
            }
          }

          let relatedBlocks = getRelatedBlocks(article, "block");

          if (relatedBlocks.length > 0) {
            let articleAddon = getRelations(relatedBlocks);
          }

          let relatedUnits = getRelatedBlocks(article, "unit");
          if (relatedUnits.length > 0) {
            rightColumn += getRelations(relatedUnits);
            if (rightColumn) {
              hasRightColumn = true;
            }
          }
        }

        var dynIntro = false;

        if (
          testDynData(
            metaData,
            "localId",
            "a8d20515-d33f-48dd-a053-9eea026f7919"
          )
        ) {
          dynIntro = getDynDataOne(
            metaData,
            "a8d20515-d33f-48dd-a053-9eea026f7919",
            "localId"
          ).value; // Forsidetekst.
        }

        var intro = article.intro || dynIntro || "";

        $("#currentPageBreadcrumb").text(article.title);

        let title = article.title || "";
        let imageSpan = "col";
        if (article.pageTypeId === "mal_enhetsmal") {
          imageSpan = "col-md-12";
        }

        content = checkDocument(content, allRelateds);

        // console.log(article);
        //let created = dayjs(article.created).format("DD.MM.YYYY kl. hh:mm");
        // let modified = ``;
        //if (created != dayjs(article.modified).format("DD.MM.YYYY kl. hh:mm")) {
        //    modified = `<span class="article__datetext__label">Oppdatert:</span>${dayjs(article.modified).format("DD.MM.YYYY kl. hh:mm")}`;
        //}

        let created = dayjs(article.created).format("DD.MM.YYYY");
        let published = dayjs(article.firstCreated).format("DD.MM.YYYY");
        let modified = dayjs(article.modified).format("DD.MM.YYYY");

        article.imageSpan = imageSpan;
        article.mainImage = mainImage;
        article.textareaWidth = "col-md-7";
        if (article.pageTypeId == "mal_nyhet") {
          article.textareaWidth = "col-md-10";
        }
        article.articleMarginLeft = "";
        if (article.pageTypeId == "mal_enhetsmal") {
          article.articleMarginLeft = "ml-md-4";
        }
        article.title = title;
        article.parsedIntro = intro;
        article.content = content;
        article.created = created;
        article.firstCreated = published;
        article.modified = modified;
        article.hasRightColumn = hasRightColumn;
        article.rightColumn = rightColumn;

        // console.log(article.pageTypeId)

        let contentHtml = article_default(article);
        if (article.pageTypeId === "fokusartikkel") {
          contentHtml = article_focusarticle(article);
        } else if (article.pageTypeId === "bti-forside") {
          contentHtml = article_bti_frontpage(article);
        }

        $("#contentHtml").html(contentHtml);

        if (sessionStorage.getItem("fromcms") === "true") {
          $("body").append(`
                        <div class="" style="position:fixed; bottom: 10px; right:10px; z-index:10000;"><div class="row"><div class="col">
                        <a class="btn btn-warning btn-lg" href="https://aim-admin.azurewebsites.net/dashboard/nytt-innhold?id=${article.contentId}">Rediger denne siden</a>
                        </div></div></div>
                    `);
        }

        createGallery();
        setResponsiveImages();
        setImageText();
        skjema_inline();
      });
  };

  getArticle();
}
